








import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import FormBase from '@/components/helper/form-base.vue';
import ModalView from '@/components/helper/modal-view.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Sale from '@/store/entities/cems/sale';

@Component({
    components: { FormBase, ModalView },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.sale = Util.extend(true, {}, this.$store.state.sale.editModel);
                obj.initForm();
            }
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class SaleForm extends ListBase {
    entity: string = "sale";
    @Prop({ type: Boolean, default: false }) value: boolean;
    sale: Sale = new Sale();
    modalShow: boolean = false;
    tabModel: any = null;
    modalSetting: any = {
        entity: "sale",
        titleFull: 'Postventa',
        width: "1000px",
        showForm: false
    };


    items = [
        this.gItem({ type: 'subheader', subheader: 'Informacion' }),
        this.gItem({ type: 'number', prop: 'number', label: 'Transaction Id', size: 3, prefix: '#', required: true }),
        this.gItem({ type: 'date', prop: 'service_date', label: 'Transaction date', size: 3 }),
        this.gItem({ type: 'object', prop: 'dealer_id', label: 'Dealer', entity: 'dealer', required: true, size: 3 }),
        this.gItem({ type: 'text', prop: 'service_type', label: 'Service Type', size: 3 }),
        this.gItem({ type: 'text', prop: 'lang', label: 'Idioma', size: 3, hideDetails: true }),
        this.gItem({ type: 'object', prop: 'country_id', label: 'Pais', size: 3, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'assessor_name', label: 'Survey name', size: 3, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'city', label: 'Associate', size: 3, hideDetails: true }),          

        this.gItem({ type: 'divider', subheader: 'Cliente' }),
        this.gItem({ type: 'text', prop: 'customer', label: 'First name', size: 4 }),
        this.gItem({ type: 'text', prop: 'technician_name', label: 'Last name', size: 4 }),
        this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 4 }),
        this.gItem({ type: 'text', prop: 'address2', label: 'Customer Number', size: 4, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'seller_name', label: 'Customer Gender', size: 4, hideDetails: true }),
        this.gItem({ type: 'spacer', size: 4, hideDetails: true }),

        this.gItem({ type: 'divider', subheader: 'Direccion' }),
        this.gItem({ type: 'text', prop: 'address1', label: 'Form of Address', size: 6, hideDetails: true }),
        this.gItem({ type: 'phone', prop: 'phone', label: 'Phone Number', size: 3, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'postal_code', label: 'Postal Code', size: 3, hideDetails: true }),

        this.gItem({ type: 'divider', subheader: 'Otros' }),
        this.gItem({ type: 'text', prop: 'vin', label: 'VIN', size: 3, prefix: '#', hideDetails: true }),
        this.gItem({ type: 'text', prop: 'model', label: 'Brand', size: 3, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'contact', label: 'First Contact', size: 2, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'invoice', label: 'Client Segmentation', size: 2, hideDetails: true }),
        this.gItem({ type: 'text', prop: 'plate', label: 'Age Group', size: 2, hideDetails: true }),
    ]

    get dealer() {
        return this.$store.state.app.dealer;
    }

    initForm() {
        if (this.sale.id > 0) {
        } else { 
            this.sale.dealer_id = this.dealer;
        }
    }

    async save() {
        if ((this.$refs.entityForm1 as any).validate()) {
            let model = Util.extend(true, {}, this.sale);

            await this.$store.dispatch({
                type: 'sale/' + (this.sale.id > 0 ? 'update' : 'create'),
                data: model
            });
            this.$emit('save-success');
            this.cancel();
            if (this.sale.id > 0)
                Util.abp.notify.success(this, 'Registro CEM actualizada!');
            else
                Util.abp.notify.success(this, 'El Registro CEM ha sido registrado!');
        }
    }

    cancel() {
        this.$emit('input', false);
    }

    async mounted() {
    }

    async created() {
    }
}
